// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const app = initializeApp({
  apiKey: "AIzaSyD3tgalF4YmUq67bZTdfqoFrkC254JM3rU",
  authDomain: "medicomp-53eac.firebaseapp.com",
  projectId: "medicomp-53eac",
  storageBucket: "medicomp-53eac.appspot.com",
  messagingSenderId: "767435323964",
  appId: "1:767435323964:web:1744be72ab16ef7c5b2139",
  measurementId: "G-0QBZ6G66BH",
});

// Initialize Cloud Firestore and get a reference to the service
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

